module.exports = __webpack_public_path__ + "static/media/pn.3b9532b7.svg";